import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';
import buildRedirectUri from 'utils/buildRedirectUri';

const userManagerConfig = {
  client_id: 'paybyphone_corporate_admin',
  redirect_uri: buildRedirectUri('/auth/login_redirect'),
  response_type: 'code',
  scope: 'paybyphone openid',
  authority: `${process.env.REACT_APP_API_URL_IDA_AUTH}`,
  silent_redirect_uri: buildRedirectUri('/auth/silent_renew'),
  post_logout_redirect_uri: buildRedirectUri('/auth/logout_redirect'),
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  revokeAccessTokenOnSignout: true,
  includeIdTokenInSilentRenew: true,
  monitorSession: true,
  checkSessionInterval: 1000,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

const userManager = createUserManager(userManagerConfig);

userManager.events.addAccessTokenExpiring(() => {
  console.log('token expiring...');
});

userManager.events.addUserSignedOut(() => {
  userManager.signinRedirect();
});

export default userManager;
